import React, { useState, useEffect } from "react";

import newsimg1 from "../assests/img/blogs/blog1.jpg";
import newsimg2 from "../assests/img/blogs/blog2.jpg";
import newsimg3 from "../assests/img/blogs/blogs3.jpg";
import newsimg5 from "../assests/img/blogs/blog5.jpeg";

import { BsArrowRightShort } from "react-icons/bs";

import Modal from "./modal.jsx";
import "../assests/css/newsroom.scss";

import { HashLink } from "react-router-hash-link";
import { preconnect } from "react-dom";

const HelpSection = () => {
  return (
    <section id="help" className="margen-top-104">
      <div className="container">
        <h1>How can we help you?</h1>
        <p>
          Are you ready to push boundaries and explore new frontiers of
          innovation?
        </p>
        {/* Use a form with a button */}

        <HashLink smooth to={"/contactus/#"} id="help-btn">
          Let's Work Together
        </HashLink>
      </div>
    </section>
  );
};

function BlogSection() {
  useEffect(() => {
    document.title = "Explore Our Latest Company Updates! | Company News";
  }, []);
  return (
    <>
      <section className="the-section at-minh-auto ">
        <div className="img-banner img-company-news"></div>
        <div className="container">
          <div className="row text-white">
            <div className="col-md-12  text-start">
              <div className="the">
                <div className="the-display">
                  <h6>Insights - Achievements</h6>
                  <h1>
                    Haantlay's <br /> Achievements & <br /> Milestones!{" "}
                  </h1>
                  {/* <HashLink smooth to={"/contactus/"} id="button-light-bg" className='text-dicoration-none margin-bottom'>GET IN TOUCH</HashLink> */}

                  <Modal />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

function BlogContent() {
  return (
    <>
      <div id="insights"></div>
      <div id="news"></div>
      <section id="blogs-body" className="container">
        <div className="row">
          {/* Left Column with one card */}
          <div className="col-lg-6 left-m-0">
            <div className="blog-card left-blog-card">
              <div className="p-0">
                <div className="card-first">
                  <h6>OUR FEATURED INSIGHTS</h6>
                  <h1 className="rgb-low">
                    BS-Block Renamed to Mehar Hasnat Block
                  </h1>
                  <HashLink
                    smooth
                    to={
                      "/source/topics/company-news=University-of-Chakwal-renames-BS-Block-to-Mehar-Hasnat-Block/#article"
                    }
                    id="blog-link"
                    className="text-dicoration-none margin-bottom"
                  >
                    READ MORE
                  </HashLink>
                  <BsArrowRightShort className="blog-link-icon" />
                </div>
                <div className="">
                  <img
                    src="https://pub-e63224eb5de14c74b56d17732ca35046.r2.dev/blog4.JPG"
                    className="img-fluid p-0 blog-img mar-3 ct"
                    alt="Blog"
                    rel="preconnect"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Right Column with three cards */}
          <div className="col-lg-6 right-m-0">
            <div className="row">
              <div className="col-12">
                <div className="blog-card right-blog-card">
                  <div className="c-text p-0 m-0 lgorder2">
                    <h1>Mehar Hasnat Ahmed Receives HEC High Achiever Award</h1>
                    <HashLink
                      smooth
                      to={
                        "/source/topics/company-news=High-Achiever-Award/#article"
                      }
                      id="blog-link"
                      className="text-dicoration-none margin-bottom"
                    >
                      READ MORE
                    </HashLink>
                    <BsArrowRightShort className="blog-link-icon" />
                  </div>
                  <div className="c-img p-0 m-0 lgorder1">
                    <img
                      src={newsimg3}
                      className="img-fluid p-0 blog-img cc"
                      alt="Blog"
                    />
                  </div>
                </div>
              </div>

              <div className="col-12">
                <div className="blog-card right-blog-card">
                  <div className="c-text p-0 m-0 lgorder2">
                    <h1>1st Position in Coding at SoftFest 2024</h1>
                    <HashLink
                      smooth
                      to={
                        "/source/topics/company-news=A-Remarkable-Achievement-by-Haantlay's-Chairman"
                      }
                      id="blog-link"
                      className="text-dicoration-none margin-bottom"
                    >
                      READ MORE
                    </HashLink>
                    <BsArrowRightShort className="blog-link-icon" />
                  </div>
                  <div className="c-img p-0 m-0 lgorder1">
                    <img
                      src={newsimg5}
                      className="img-fluid p-0 blog-img ct"
                      alt="Blog"
                    />
                  </div>
                </div>
              </div>

              <div className="col-12">
                <div className="blog-card right-blog-card">
                  <div className="c-text p-0 m-0 lgorder2">
                    <h1>A Triumph in Speed Coding at the WEC Olympiad</h1>
                    <HashLink
                      smooth
                      to={
                        "/source/topics/company-news=A-Triumph-in-Speed-Coding-at-the-WEC-Olympiad/#article"
                      }
                      id="blog-link"
                      className="text-dicoration-none margin-bottom"
                    >
                      READ MORE
                    </HashLink>
                    <BsArrowRightShort className="blog-link-icon" />
                  </div>
                  <div className="c-img p-0 m-0 lgorder1">
                    <img
                      src={newsimg2}
                      className="img-fluid p-0 blog-img cb"
                      alt="Blog"
                    />
                  </div>
                </div>
              </div>

              <div className="col-12">
                <div className="blog-card right-blog-card">
                  <div className="c-text p-0 m-0 lgorder2">
                    <h1>Haantlay Secures 2nd Position at IEEE Expo </h1>
                    <HashLink
                      smooth
                      to={
                        "/source/topics/company-news=Haantlay-Secures-2nd-Position-at-IEEE-Expo/#article"
                      }
                      id="blog-link"
                      className="text-dicoration-none margin-bottom"
                    >
                      READ MORE
                    </HashLink>
                    <BsArrowRightShort className="blog-link-icon" />
                  </div>
                  <div className="c-img p-0 m-0 lgorder1">
                    <img
                      src={newsimg1}
                      className="img-fluid p-0 blog-img ct"
                      alt="Blog"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BlogSection />

      <BlogContent />

      <HelpSection />
    </div>
  );
}

export default App;
